import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fs13" }, "概要", -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fs13" }, "調整内容", -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "fs13" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "fs13" }
const _hoisted_10 = {
  class: "dropdown-toggle posRe w100 centered scheduleTabSP",
  style: {}
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "fs13" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "fs12"
}
const _hoisted_16 = {
  class: "fr",
  style: {"width":"20px","margin-top":"10px"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "roomMembersMenuHeader w100" }
const _hoisted_19 = {
  class: "fs14 fw600 fl",
  style: {"margin":"10px 0 0 10px"}
}
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "w100 roomMembersMenuTable" }
const _hoisted_22 = {
  class: "with_white_bg fl ml5 mt5",
  style: {"width":"42px","height":"42px","border-radius":"50%"}
}
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  style: {"width":"190px"},
  class: "fl whiteColor fw600 fs13 text-left mt4 ml5 kaigyo"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "roomMembersMenuHeader w100" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs14 fw600 fl",
    style: {"margin":"10px 0 0 10px"}
  })
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", { style: {"margin-top":"0px","margin-bottom":"10px"} }, null, -1)
const _hoisted_29 = { class: "" }
const _hoisted_30 = {
  key: 0,
  class: "w100 roomMembersMenuTable"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertBadge = _resolveComponent("AlertBadge")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_RoomMembersMenuTr = _resolveComponent("RoomMembersMenuTr")!

  return (_ctx.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showSPHeader())
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: "posFi w100",
              style: _normalizeStyle({
                height: `50px`,
                zIndex: 10,
                marginTop: _ctx.Util.isGuest() ? `0px` : `60px`,
            })
            }, [
              (_ctx.headersMenu.includes(`apc`))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`posRe fl centered scheduleTabSP ${_ctx.selectedTab == `apc` ? `selected` : ``}`),
                    style: _normalizeStyle(_ctx.menuTabWidth),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSchedule(`apc`)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/pageicon.png`),
                      class: "mr5",
                      style: {"width":"20px","height":"20px","margin-top":"-4px"}
                    }, null, 8, _hoisted_2),
                    _hoisted_3
                  ], 6))
                : _createCommentVNode("", true),
              (_ctx.headersMenu.includes(`appo`))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`posRe fl centered scheduleTabSP ${_ctx.selectedTab == `appo` ? `selected` : ``}`),
                    style: _normalizeStyle(_ctx.menuTabWidth),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSchedule(`appo`)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/pageicon.png`),
                      class: "mr5",
                      style: {"width":"20px","height":"20px","margin-top":"-4px"}
                    }, null, 8, _hoisted_4),
                    _hoisted_5
                  ], 6))
                : _createCommentVNode("", true),
              (_ctx.headersMenu.includes(`schedule`))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(`posRe fl centered scheduleTabSP ${_ctx.selectedTab == `schedule` ? `selected` : ``}`),
                    style: _normalizeStyle(_ctx.menuTabWidth),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSchedule(`schedule`)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_circle.png`),
                      class: "mr5",
                      style: {"width":"20px","height":"20px","margin-top":"-4px"}
                    }, null, 8, _hoisted_6),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`title.schedule`)), 1)
                  ], 6))
                : _createCommentVNode("", true),
              (_ctx.headersMenu.includes(`chat`) && this.rooms)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "fl posRe",
                    style: _normalizeStyle(_ctx.menuTabWidth)
                  }, [
                    (_ctx.isPublic || this.rooms.length == 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "posRe w100 centered scheduleTabSP",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectMessageRoom(_ctx.rm.currentMessageRoom)))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/talk_three.png`),
                            class: "mr5",
                            style: {"width":"20px","height":"20px","margin-top":"-2px"}
                          }, null, 8, _hoisted_8),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`message.chat`)), 1),
                          _createVNode(_component_AlertBadge, {
                            num: _ctx.doesUnreads,
                            display: `nonum`
                          }, null, 8, ["num"])
                        ]))
                      : (_openBlock(), _createBlock(_component_Dropdown, {
                          key: 1,
                          ref: "dropdown"
                        }, _createSlots({
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/talk_three.png`),
                                style: {"width":"20px","height":"20px","margin-top":"-2px"}
                              }, null, 8, _hoisted_11),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(`message.chat`)), 1),
                              _createVNode(_component_AlertBadge, {
                                num: _ctx.doesUnreads,
                                display: `nonum`
                              }, null, 8, ["num"])
                            ])
                          ]),
                          _: 2
                        }, [
                          (_ctx.rooms)
                            ? {
                                name: "dropdown",
                                fn: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.rooms, (childRoom, roomindex) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: `${roomindex}-${childRoom.id}-${childRoom.room_id}-${childRoom.unread_num}-${_ctx.rm.currentMessageRoom.unread_num}`,
                                      class: _normalizeClass(`w100 ${
                                childRoom && _ctx.rm.currentMessageRoom && _ctx.rm.currentMessageRoom.room_id == childRoom.room_id
                                    ? `selected`
                                    : ``
                            }`),
                                      style: {"line-height":"60px","height":"60px","padding-left":"15px"},
                                      onClick: ($event: any) => (_ctx.selectMessageRoom(childRoom))
                                    }, [
                                      (roomindex != 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createVNode(_component_IconLock, {
                                              is_white: false,
                                              class: "fl"
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      childRoom
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.truncate(childRoom.title, 13)), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("p", _hoisted_16, [
                                        _createVNode(_component_AlertBadge, {
                                          num: childRoom.unread_num,
                                          display: `num`
                                        }, null, 8, ["num"])
                                      ])
                                    ], 10, _hoisted_13))
                                  }), 128))
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1536))
                  ], 4))
                : _createCommentVNode("", true)
            ], 4))
          : (_ctx.showChat)
            ? (_openBlock(), _createElementBlock("section", {
                key: 1,
                class: "roomMembersMenu posFi",
                style: _normalizeStyle({ bottom: _ctx.isPublic ? `30px` : `` })
              }, [
                (_ctx.isPublic)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t(`message.chat`)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("table", _hoisted_21, [
                          _createElementVNode("div", {
                            class: _normalizeClass(`posAb pointer centered gradBlueBg popUpShadow`),
                            style: {"width":"248px","height":"52px","border-radius":"24px","right":"0","top":"0"},
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectMessageRoom(_ctx.room)))
                          }, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/chat.png`),
                                width: "30",
                                height: "30",
                                class: "mt6"
                              }, null, 8, _hoisted_23)
                            ]),
                            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t(`message.help_chat`)), 1)
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        (_ctx.rooms)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_30, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.rooms, (childRoom, roomindex) => {
                                return (_openBlock(), _createBlock(_component_RoomMembersMenuTr, {
                                  key: `${roomindex}-${_ctx.room.id}-${childRoom.room_id}-${childRoom.unread_num}-${_ctx.rm.currentMessageRoom.unread_num}`,
                                  room: childRoom,
                                  roomindex: roomindex,
                                  onSelectedRoom: _ctx.selectMessageRoom
                                }, null, 8, ["room", "roomindex", "onSelectedRoom"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
              ], 4))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}